import { createSlice } from "@reduxjs/toolkit";

const initialState = {};    


const signupSlice = createSlice({
    name: "signup",
    initialState,
    reducers: { 
        addField(state,action){
            if (action.type === "signup/addfield"){
            for (const [signupPropertyKey, signupPropertyValue] of Object.entries(action.payload)){
                state[signupPropertyKey] = signupPropertyValue
                }
            }
            return state;
        },
        createSignupError(state,action){
            state.isError = true
            state.error = action.payload    
        },
        removeSignupError(state,action){
             state.isError = false
             state.error = ""
         }
    }
});

export const selectSubProfile = (state) => state.signup

export const {addField, createSignupError, removeSignupError} = signupSlice.actions

export default signupSlice.reducer;